// components
import {
  styled,
  Box,
  BoxProps,
  IconButton,
  IconButtonProps,
  Typography,
  TypographyProps,
  alpha
} from '@mui/material';

export const StyledActionTooltipCloseIconButton = styled(
  IconButton
)<IconButtonProps>(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(-0.3),
  right: 0
}));

export const StyledActionTooltipBox = styled(Box)<BoxProps>({
  position: 'relative',
  width: '240px'
});

export const StyledActionTooltipContentBox = styled(Box)<BoxProps>(
  ({ theme }) => ({
    padding: theme.spacing(2, 2, 1, 2)
  })
);

export const StyledActionTooltipChildrenBox = styled(Box)<BoxProps>(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    gap: theme.spacing(1)
  })
);

export const StyledActionTooltipContainerBox = styled(
  StyledActionTooltipChildrenBox
)<BoxProps>(({ theme }) => ({
  marginTop: theme.spacing(1)
}));

export const StyledActionTooltipTypography = styled(
  Typography
)<TypographyProps>(({ theme }) => ({
  lineHeight: 1.2,
  margin: theme.spacing(0, 1),
  textAlign: 'left'
}));

export const StyledActionTooltipBackdrop = styled(Box)<BoxProps>(
  ({ theme }) => ({
    backgroundColor: alpha(theme.palette.common.black, 0.75),
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 100,
    width: '100vw',
    height: '100vh',
    transitionDuration: '250ms'
  })
);
